// extracted by mini-css-extract-plugin
module.exports = {"segment":"Segment_segment__1kvTM"};